import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import NavBot from './NavBot';
import { useAuth } from '../auth/AuthContext';
import { BugReportsProvider } from '../contexts/BugReportsContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AppShellLayout() {
  const { email, isAdmin } = useAuth();

  return (
    <BugReportsProvider>
    <div className="app-shell">
      <Sidebar />
      <div className="main">
        <TopBar />
        <main className="content">
          <Outlet />
        </main>
      </div>
      <NavBot userId={email} userName={email} isSuperUser={isAdmin} />
      <ToastContainer
        position="bottom-right"
        theme="dark"
        autoClose={6000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </div>
    </BugReportsProvider>
  );
}
